import { render, staticRenderFns } from "./SkinItems.vue?vue&type=template&id=3e155b30&"
import script from "./SkinItems.vue?vue&type=script&lang=js&"
export * from "./SkinItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports